var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleScvpu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3780_6366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 54C41.9117 54 54 41.9117 54 27C54 12.0883 41.9117 0 27 0C12.0883 0 0 12.0883 0 27C0 41.9117 12.0883 54 27 54Z",
    fill: "#00838F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1728 29.5355C49.0986 28.7716 48.5999 28.1139 47.8785 27.838L45.1838 26.7771C44.7807 26.618 44.4306 26.3316 44.1972 25.9602L40.2719 19.7115C39.9005 19.1174 39.2428 18.7461 38.532 18.7461H32.209V33.7473H49.6078L49.1728 29.5355Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4257 26.5217L38.7443 20.6655C38.7019 20.5913 38.617 20.5488 38.5321 20.5488H34.0127V26.5217H42.4257Z",
    fill: "#4485C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9261 33.7363H32.209V37.7465H49.9367C50.4247 37.7465 50.8172 37.354 50.8172 36.866V34.6169C50.8172 34.1395 50.4141 33.7363 49.9261 33.7363Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7239 12.6465H5.69718C4.88028 12.6465 4.21191 13.3149 4.21191 14.1317V37.7475H32.1986V14.1317C32.2092 13.3149 31.5408 12.6465 30.7239 12.6465Z",
    fill: "#FBD303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1986 33.7363H4.21191V37.7465H32.1986V33.7363Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2422 37.5879C20.2422 34.7447 17.94 32.4531 15.1074 32.4531C12.2748 32.4531 9.97266 34.7553 9.97266 37.5879C9.97266 37.6409 9.98327 37.694 9.98327 37.747H20.2422C20.2422 37.694 20.2422 37.6409 20.2422 37.5879Z",
    fill: "#333842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2271 32.4531C38.3838 32.4531 36.0923 34.7553 36.0923 37.5879C36.0923 37.6409 36.1029 37.694 36.1029 37.747H46.3618C46.3618 37.694 46.3724 37.6409 46.3724 37.5879C46.3724 34.7553 44.0703 32.4531 41.2271 32.4531Z",
    fill: "#333842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2268 42.0005C43.6643 42.0005 45.6402 40.0246 45.6402 37.5872C45.6402 35.1498 43.6643 33.1738 41.2268 33.1738C38.7894 33.1738 36.8135 35.1498 36.8135 37.5872C36.8135 40.0246 38.7894 42.0005 41.2268 42.0005Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2266 40.0381C42.58 40.0381 43.6773 38.9409 43.6773 37.5874C43.6773 36.2339 42.58 35.1367 41.2266 35.1367C39.8731 35.1367 38.7759 36.2339 38.7759 37.5874C38.7759 38.9409 39.8731 40.0381 41.2266 40.0381Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1072 42.0005C17.5446 42.0005 19.5206 40.0246 19.5206 37.5872C19.5206 35.1498 17.5446 33.1738 15.1072 33.1738C12.6698 33.1738 10.6938 35.1498 10.6938 37.5872C10.6938 40.0246 12.6698 42.0005 15.1072 42.0005Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1074 40.0381C16.4609 40.0381 17.5581 38.9409 17.5581 37.5874C17.5581 36.2339 16.4609 35.1367 15.1074 35.1367C13.7539 35.1367 12.6567 36.2339 12.6567 37.5874C12.6567 38.9409 13.7539 40.0381 15.1074 40.0381Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3213 37.6348C42.3213 38.2561 41.8176 38.7598 41.1963 38.7598C40.575 38.7598 40.0713 38.2561 40.0713 37.6348C40.0713 37.0134 40.575 36.5098 41.1963 36.5098C41.8176 36.5098 42.3213 37.0134 42.3213 37.6348Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 37.625C16.125 38.2463 15.6213 38.75 15 38.75C14.3787 38.75 13.875 38.2463 13.875 37.625C13.875 37.0037 14.3787 36.5 15 36.5C15.6213 36.5 16.125 37.0037 16.125 37.625Z",
    fill: "#414753"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3780_6366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleScvpu);
export default __webpack_public_path__ + "static/media/Vehicle-SCV&PU.c664928e4f5e03a1e8cbcdcb63c17434.svg";
export { ForwardRef as ReactComponent };